import React from "react";
import PropTypes from "prop-types";
import styles from "./ConfirmationModal.module.css";
import classNames from "classnames";
import ModalActionBar from "shared/ModalActionBar";

/**
 * Interactive component.
 * Modal used throughout the app for multiple purposes (e.g. deleting, creating, syncing).
 */
export function ConfirmationModal({
  header,
  isOpen,
  onClose,
  onClick,
  description,
  btnName,
  children,
  className,
}) {
  return (
    <div
      className={classNames(styles.overlay, {
        [styles.hidden]: !isOpen,
      })}
    >
      <>
        <div className={styles.modalBackground} onClick={onClose} />
        <div className={classNames(styles.container, className)}>
          <div className={classNames(styles.title, styles.bold)}>{header}</div>
          <div className={styles.hr} />
          <div className={styles.description}>{description}</div>
          <div className={styles.children}>{children}</div>
          <div className={styles.buttonContainer}>
            <ModalActionBar
              children={
                <div className={styles.bold}>
                  <button
                    type="button"
                    className={classNames(styles.button, styles.cancelBtn)}
                    onClick={onClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className={classNames(
                      btnName.includes("Delete")
                        ? styles["delete-button"]
                        : styles.button
                    )}
                    onClick={onClick}
                  >
                    {btnName}
                  </button>
                </div>
              }
            />
          </div>
        </div>
      </>
    </div>
  );
}

ConfirmationModal.propTypes = {
  /**
   * Header at the top of the modal.
   * Also used to display the button's name.
   */
  header: PropTypes.string,
  /**
   * Getter to determine if the the modal is displayed.
   */
  isOpen: PropTypes.bool,
  /**
   * Callback function for when the modal is closed.
   */
  onClose: PropTypes.func,
  /**
   * Function called when the remove/delete button is clicked.
   */
  onClick: PropTypes.func,
  /**
   * Displays the information of what is being removed.
   */
  description: PropTypes.string,
  /**
   * Name displayed on the button (remove/delete).
   */
  btnName: PropTypes.string,
  /**
   * Children added between the description and ModalActionBar.
   */
  children: PropTypes.element,
  /**
   * Classname for the modal to control the width, etc.
   */
  className: PropTypes.string,
};
